import React from 'react';

const OrderSettingsContext = React.createContext({
  settings: [],
  updateSettings: () => undefined,
  getSettingsForLocation: () => undefined,
});

export default OrderSettingsContext;
